import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceHeaderType  {
    _originalTypeClassName = "zERP.BO.InvoiceHeaderType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceHeaderType.translate = translateService;
}
this.Id = null;
this.Series = null;
this.AA = null;
this.IssueDate = null;
this.VatPaymentSuspension = false;
this.ExchangeRate = null;
this.SelfPricing = false;
this.DispatchDate = null;
this.DispatchTime = null;
this.VehicleNumber = null;
this.MovePurpose = null;
this.CorrelatedInvoices = null;
this.GetInvoiceType = null;
this.CurrencyStr = null;
this.InvoiceStr = null;
this.MovePurposeStr = null;
this.ERPAA = null;
this.ERPDocID = null;
this.ERPAlterDocID = null;
this.ERPAlterDocDate = null;
this.ERPInitialDocDate = null;
this.FuelInvoice = false;
this.InvoiceTypeString = null;
this.SeriesAndAA = null;
this.IsDeliveryNote = false;
this.Reason = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Series:any;
AA:any;
IssueDate:any;
VatPaymentSuspension:any;
ExchangeRate:any;
SelfPricing:any;
DispatchDate:any;
DispatchTime:any;
VehicleNumber:any;
MovePurpose:any;
CorrelatedInvoices:any;
GetInvoiceType:any;
CurrencyStr:any;
InvoiceStr:any;
MovePurposeStr:any;
ERPAA:any;
ERPDocID:any;
ERPAlterDocID:any;
ERPAlterDocDate:any;
ERPInitialDocDate:any;
FuelInvoice:any;
InvoiceTypeString:any;
SeriesAndAA:any;
IsDeliveryNote:any;
Reason:any;
ERPInvoiceCategory:any;
ERPInvoiceType:any;
SpecialInvoiceCategory:any;
InvoiceVariationType:any;
ERPSeries:any;
InvoiceType:any;
Currency:any;
OtherDeliveryNoteHeaderType:any;
static setERPInvoiceCategory = ($this, value) => {
var oldValue = $this.ERPInvoiceCategory;
$this.ERPInvoiceCategory = value;
if (value != null) {
}
}
static setERPInvoiceType = ($this, value) => {
var oldValue = $this.ERPInvoiceType;
$this.ERPInvoiceType = value;
if (value != null) {
}
}
static setSpecialInvoiceCategory = ($this, value) => {
var oldValue = $this.SpecialInvoiceCategory;
$this.SpecialInvoiceCategory = value;
if (value != null) {
}
}
static setInvoiceVariationType = ($this, value) => {
var oldValue = $this.InvoiceVariationType;
$this.InvoiceVariationType = value;
if (value != null) {
}
}
static setERPSeries = ($this, value) => {
var oldValue = $this.ERPSeries;
$this.ERPSeries = value;
if (value != null) {
}
}
static setInvoiceType = ($this, value) => {
var oldValue = $this.InvoiceType;
$this.InvoiceType = value;
if (value != null) {
}
}
static setCurrency = ($this, value) => {
var oldValue = $this.Currency;
$this.Currency = value;
if (value != null) {
}
}
static setOtherDeliveryNoteHeaderType = ($this, value) => {
var oldValue = $this.OtherDeliveryNoteHeaderType;
$this.OtherDeliveryNoteHeaderType = value;
if (value != null) {
}
}

static FillSpecified($this: any): any{if (($this?.DispatchDate != null)) {}
if (($this?.DispatchTime != null)) {}
if ((CLMS.Framework.Number.NotEqual(() => $this.ExchangeRate, () => null))) {}
if ((CLMS.Framework.Number.NotEqual(() => $this.MovePurpose, () => null))) {}
if (($this?.SelfPricing != null)) {}
if (($this?.VatPaymentSuspension != null)) {}
}
static GetInvoiceTypes(): any{let invoiceTypeOptions = [];
let invoiceTypes = Domain.InvoiceTypeValueObject.GetEnums();
for (let _iinvoiceType = 0; _iinvoiceType < (invoiceTypes == null ? 0 : invoiceTypes.length); _iinvoiceType++) {let invoiceType = invoiceTypes[_iinvoiceType];let item = new Domain.InvoiceTypeOptionDTO();item.Value = invoiceType;item.Display = Domain.InvoiceTypeValueObject.InvoiceTypeToString(invoiceType);invoiceTypeOptions?.add(item);}
return invoiceTypeOptions;
}
static GetInvoiceTypeString($this: any): any{if ($this?.InvoiceType?.SkipMyDataSync) {return $this?.InvoiceType?.Name;}
return Domain.InvoiceTypeValueObject.InvoiceTypeToString($this?.InvoiceType?.Code);
}
static GetInvoiceTypeToEnum(invoiceType: any): any{let ser = new CLMS.Framework.Utilities.Serializer<any>();
let myenum = ser.ParseEnum(invoiceType);
return myenum;
}
static GetSeriesAndAA($this: any): any{return $this?.Series + "-" + $this?.AA;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}